/**
 * Config: Timings
 * -----------------------------------------------------------------------------
 * Global configuration for consistent values for timing durations.
 * - This file is automatically generated by yarn design, do not edit.
 *
 */
// eslint-disable

export const values = {
  quick: 0.1,
  normal: 0.3,
  slow: 0.6,
  message: 3,
}

export default {
  quick: values.quick * 1000,
  normal: values.normal * 1000,
  slow: values.slow * 1000,
  message: values.message * 1000,
}
